import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = ({ className = '' }) => {
  const { i18n } = useTranslation();
  
  const toggleLanguage = () => {
    const newLang = i18n.language === 'tr' ? 'en' : 'tr';
    i18n.changeLanguage(newLang);
  };
  
  return (
    <button
      onClick={toggleLanguage}
      className={`language-switcher ${className}`}
      title={i18n.language === 'tr' ? 'Switch to English' : 'Türkçe\'ye geç'}
      data-testid="language-switcher"
    >
      <Globe size={18} />
      <span className="language-code">{i18n.language.toUpperCase()}</span>
    </button>
  );
};

export default LanguageSwitcher;
